export const pick = (obj, keys, fallback = undefined) => {
  if (!obj) return fallback;
  for (const k of keys) {
    if (obj[k] !== undefined && obj[k] !== null && obj[k] !== "") return obj[k];
  }
  return fallback;
};

export const asList = (data) => {
  if (Array.isArray(data)) return data;
  if (!data) return [];
  for (const k of ["items", "results", "professionals", "users", "requests", "reports", "audit", "entries", "data"]) {
    if (Array.isArray(data[k])) return data[k];
  }
  return [];
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("it-IT", { day: "numeric", month: "short", year: "numeric" });
  } catch { return "—"; }
};
